import { render, staticRenderFns } from "./EdDrawer.vue?vue&type=template&id=2274e92e&scoped=true&"
import script from "./EdDrawer.vue?vue&type=script&lang=js&"
export * from "./EdDrawer.vue?vue&type=script&lang=js&"
import style0 from "./EdDrawer.vue?vue&type=style&index=0&id=2274e92e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2274e92e",
  null
  
)

export default component.exports